import React from "react";

export default class Garments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggle: false,
    };
  }

  render() {
    return (
      <div className="healthcheck">
        <h2>복장검사를 진행해주세요.</h2>
        <div className="healthcheck-container">
          <div className="healthcheck-tb">
            <div className="healthcheck-td" id="s-cover">
              <div className="healthcheck-button">
                <img
                  src="https://img.icons8.com/plasticine/100/000000/military-uniform.png"
                  alt="복장"
                />
              </div>
            </div>
            <div className="healthcheck-td">
              <div className="toggle checkcross">
                <input
                  id="checkcross"
                  type="checkbox"
                  name="garments"
                  onChange={this.props.change}
                />
                <label className="toggle-item" htmlFor="checkcross">
                  <div className="check"></div>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
